import gql from 'graphql-tag';

export const CREATE_NEW_CHECKOUT_ID_MUTATION = gql`
  mutation newPayment(
    $testatorId: ID!
    $paymentPlan: PaymentPlanEnum!
    $tokenizeOnly: Boolean
    $voucherCode: String
  ) {
    initialiseNewPayment(
      testatorId: $testatorId
      paymentPlan: $paymentPlan
      tokenizeOnly: $tokenizeOnly
      voucherCode: $voucherCode
    )
  }
`;
export const PROCESS_PAYMENT_MUTATION = gql`
  mutation processPayment($transactionId: String!, $resourcePath: String!) {
    processPayment(transactionId: $transactionId, resourcePath: $resourcePath) {
      code
      description
      successfulPayment
      firstPayment
      amount
      transactionType
      transactionId
    }
  }
`;
export const PAY_WITH_EXISTING_CARD_MUTATION = gql`
  mutation payWithExistingCard(
    $registrationId: String!
    $redirectUrl: String!
    $paymentPlan: PaymentPlanEnum!
  ) {
    payWithExistingCard(
      registrationId: $registrationId
      redirectUrl: $redirectUrl
      paymentPlan: $paymentPlan
    ) {
      url
      paReq
      MD
      termUrl
    }
  }
`;
export const TESTATOR_TRANSACTIONS_QUERY = gql`
  query registrationCards($testatorId: ID!) {
    registrationCards(testatorId: $testatorId) {
      expiryMonth
      expiryYear
      last4Digits
      registrationId
    }
  }
`;

export const REDEEM_FIRST_WILL_FREE_MUTATION = gql`
  mutation redeemFirstWillFree(
    $testatorId: ID!
    $paymentPlan: PaymentPlanEnum!
  ) {
    redeemFirstWillFree(testatorId: $testatorId, paymentPlan: $paymentPlan)
  }
`;
